import React,{Component} from "react";
import { Container, Row, Col, Card, CardHeader, CardBody, Button,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormSelect,

   } from "shards-react";
import { Redirect } from 'react-router';
import PageTitle from "../common/PageTitle";
import AddStudent from './AddStudent';
import firebase from '../firebase';
import '../style.css';
import { AtomSpinner } from 'react-epic-spinners';
import { toast } from 'react-toastify';
import ViewStudent from './ViewStudent';
import ConfirmModal from '../ConfirmModal';
import EditStudent from './EditStudent';

export default class Student extends Component{

    constructor(props) {
      super(props);
    
      this.state = {add_student:false,
                    class_list:[],
                    loading:false,
                    student_list:[],
                    fetched:false,
                    selected_class:"Select Class",
                    ShowViewStudent:false,
                    viewrollno:null,
                    viewstudentdata:null,
                    deletestudentcode:null,
                    showConfirmModal:false,
                    ShowViewStudentModal:false,
                    showEditModal:false,
                    edit_student_code:null,
                    logged_in:false,
                  };


      this.ShowViewStudent = this.ShowViewStudent.bind(this);
      this.ShowAddStudent = this.ShowAddStudent.bind(this);
      this.onClassChange = this.onClassChange.bind(this);
      this.get_class_list = this.get_class_list.bind(this);
      this.sort_student_list = this.sort_student_list.bind(this);
      this.swap = this.swap.bind(this);
      this.partition = this.partition.bind(this);
      this.setViewStudentVisibility = this.setViewStudentVisibility.bind(this);
      this.ViewStudentData = this.ViewStudentData.bind(this);
      this.get_individual_student_data = this.get_individual_student_data.bind(this);
      this.delete_student = this.delete_student.bind(this);
      this.setConfirmModalVisibility = this.setConfirmModalVisibility.bind(this);
      this.delete_data_pre_requirement = this.delete_data_pre_requirement.bind(this);
      this.setEditModalVisibility = this.setEditModalVisibility.bind(this);
    }


    get_class_list = ()=>{
        var that = this;
        this.setState({loading:true});
        
        firebase.firestore().collection('ClassList').doc('list').get().then(function(doc){
          var class_list = doc.data().classes;
          class_list.shift();  //removes first element in array
          
          that.setState({loading:false,class_list:class_list});

        })
  }


  //quick sort

  sort_student_list = (arr,left,right)=>{

       var pivot,partitionIndex;
      if(left < right){
            pivot = right;
            partitionIndex = this.partition(arr, pivot, left, right);
            //sort left and right
            this.sort_student_list(arr, left, partitionIndex - 1);
            this.sort_student_list(arr, partitionIndex + 1, right);
      }
      return arr;
  }

  partition = (arr, pivot, left, right)=>{
    console.log(arr[0].name,pivot);
   var pivotValue = arr[pivot].name,
       partitionIndex = left;

   for(var i = left; i < right; i++){
      if(arr[i].name < pivotValue){
        this.swap(arr, i, partitionIndex);
        partitionIndex++;
      }
    }
    this.swap(arr, right, partitionIndex);
    return partitionIndex;
  }

  swap=(arr, i, j)=>{
    var temp = arr[i];
    arr[i] = arr[j];
    arr[j] = temp;
  }
        
    

  onClassChange = ()=>{
      var that = this;
      this.setState({loading:true,student_list:[]});

      var class_name = this.state.selected_class;      
      firebase.firestore().collection('StudentList').doc(class_name).get().then(function(doc){
          if(!doc.exists){
              that.setState({fetched:true,loading:false});
          }
          else{
            var student_arr = doc.data().students;
            student_arr = that.sort_student_list(student_arr,0,student_arr.length-1);
            that.setState({fetched:true,student_list:student_arr,loading:false});
          }
          console.log(that.state);
      })
  }

  componentDidMount(){
      this.get_class_list();
    }


    ShowViewStudent = ()=>{
      this.setState({add_student:false});
    }
    
    ShowAddStudent = ()=>{
      this.setState({add_student:true});
    }

    
    setViewStudentVisibility =(data)=>{
      if(data==="close"){
        this.setState({ShowViewStudentModal:false});
      }
      else{
          this.setState({ShowViewStudentModal:true});
      }
    }
    setConfirmModalVisibility =(data)=>{
      if(data==="close"){
        this.setState({showConfirmModal:false});
      }
      else{
          this.setState({showConfirmModal:true});
      }
    }


    delete_student=(data)=>{

       var func_ref = firebase.functions().httpsCallable('DeleteStudent');
       var stu_data ={class:data[0],roll_no:data[1]}; 
       console.log(stu_data);
       var that = this;
       this.setConfirmModalVisibility('close');

       this.setState({loading:true});
       func_ref(stu_data).then(function(result) {
                  // Read result of the Cloud Function.
                  var data = result.data;
                  console.log(data);
                  if(data.status==="success"){
                        console.log("Document succesfully deleted!");
                        toast('Student  Deleted Successfully !', {containerId: 'A'});
                        that.setState({loading:false});
                        that.onClassChange(); //get new data
                   }
                  else{
                        toast(data.error.message, {containerId: 'A'});
                        console.log(data.error.message);
                        that.setState({loading:false});
                  }

        }).catch(function(error) {
                  // Getting the Error details.
                  //var code = error.code;
                  //var message = error.message;
                  //var details = error.details;
                  // ...
                  console.log(error);
                  that.setState({loading:false});
                  toast("unable to delete Student", {containerId: 'A'});
        });
        
  

    }

    ViewStudentData = (classname,roll_no)=>{
      this.setState({viewrollno:classname+""+roll_no,viewstudentdata:null,loading:true},this.get_individual_student_data);
    }

    get_individual_student_data = ()=>{
        var that = this;
        if(this.state.viewrollno!==null){          
        firebase.firestore().collection('Student').doc(this.state.viewrollno).get().then(function(doc){
            if(doc.exists){
              console.log(that.state.viewstudentdata);
              that.setState({viewstudentdata:doc.data()});
              that.setState({loading:false});
              that.setViewStudentVisibility('open');
              console.log(that.state.viewstudentdata);
           }
          else{
              toast("unable to Get Student", {containerId: 'A'});
              that.setState({loading:false});
          }
          console.log("Completing fetch data");
        }).catch(function(err){
          console.log(err);
        })
      }
    }

    delete_data_pre_requirement = (classname,roll_no) =>{
          console.log(classname+roll_no);
          var arr=[];
          arr.push(classname);arr.push(roll_no);
          this.setState({deletestudentcode:arr});
          this.setConfirmModalVisibility('open')
    }

    setEditModalVisibility = (data) =>{
          if(data==="close"){
                  this.setState({showEditModal:false});
          }
          else{
                this.setState({showEditModal:true});
          }   
    }

    componentWillMount(){
    var that = this;
    var user = firebase.auth().currentUser;

      if (user) {
            // User is signed in.
            this.setState({logged_in:true});
      } else {
          // No user is signed in.
          this.setState({logged_in:false});
      }

  }




		render(){

    if(this.state.logged_in){
        //do nothing
    }
    else{
      return <Redirect push to="/login" />;
    }

			return (

	<Container fluid className="main-content-container px-4">
    {/* Page Header */}
    <Row noGutters className="page-header py-4">
      <PageTitle sm="4" title="Students" subtitle="All" className="text-sm-left" />
    </Row>

    <div style={{height:"100%",width: '35%'}}>

    <SelectClass onChangeHandler={(evt)=>{this.setState({selected_class:evt.target.value},this.onClassChange)}}
                  loading={this.state.loading}
                  class_list={this.state.class_list} />

     
  

    </div>

    <Row>
      <Col>
        <Card small className="mb-4">
          <CardHeader className="border-bottom">
            <Row>
            	<h6 className="m-1" style={{}}>Students</h6>

             
            	
            	<div  style={{marginLeft: '75%'}}>
              {
                (!this.state.add_student && !this.state.loading && (this.state.class_list.length>0)) &&
            		  <Button size="sm" theme="info" className="mb-2 mr-1" onClick={()=>this.ShowAddStudent()}>
            				  Add new Student
      				    </Button>
              }
              {
                this.state.add_student &&
                <Button size="sm" theme="success" className="mb-2 mr-1" onClick={()=>this.ShowViewStudent()}>
                    View Student
                </Button>
              }
      			</div>
			</Row>
            
          </CardHeader>
          
          <CardBody className={"pt-0 pb-3 "+(this.state.add_student?"":"scroll_list-group")}>
            

            {
            
            (!this.state.add_student && !this.state.loading && !(this.state.fetched && this.state.student_list.length===0) && !(this.state.selected_class==="Select Class") ) &&
            
            <table className="table mb-0">
              <thead className="bg-light" responsive hover >
                <tr>
                  <th scope="col" className="border-0">
                    #
                  </th>
                  <th scope="col" className="border-0">
                     Photo
                  </th>
                  <th scope="col" className="border-0">
                    Name
                  </th>
                  <th scope="col" className="border-0">
                    Roll No 
                  </th>
                  <th scope="col" className="border-0">
                      View
                  </th>
                  <th scope="col" className="border-0">
                    	Edit
                  </th>
                  <th scope="col" className="border-0">
                    	Delete
                  </th>
                  
                </tr>
              </thead>
             <tbody >
                    {
                      this.state.student_list.map((item,i)=>{
                                        return <TRow key={i} student_list={item} index={i+1}
                                                  ViewStudent={this.ViewStudentData}
                                                  delete_student={this.delete_data_pre_requirement}
                                                  edit_student={(code)=>{this.setState({edit_student_code:code});this.setEditModalVisibility('show');}}/>
                         })
                    }
              </tbody>
            </table>
          }
          {
            (!this.state.loading && this.state.fetched && this.state.student_list.length===0 && !this.state.add_student) &&

            
                    <div style={{marginTop: '10%'}} className="text-muted">
                        <div  style={{fontSize:40,textAlign: 'center' }}>
                          {"No Students are Added"}
                        </div>
                        <div style={{margin: '2%',marginLeft: "40%"}}>
                            <Button theme="info" size="lg" onClick={()=>{this.ShowAddStudent()}}>Add Student</Button>
                        </div>                  
                    </div>
          
          }

          {
            (!this.state.loading && this.state.selected_class==="Select Class" && !this.state.add_student ) &&

            
                    <div style={{marginTop: '10%'}} className="text-muted">
                        <div  style={{fontSize:40,textAlign: 'center',color:'blue' }}>
                          {"Please Select a Class"}
                        </div>
                        <div style={{margin: '2%',marginLeft: "0%",fontSize: 60,textAlign: 'center',color:'blue'}}>
                             <i class="material-icons">call_missed</i>  
                        </div>                  
                    </div>
          
          }

           {
                  (this.state.loading) &&
                    <div style={{margin: '10%',marginLeft: '40%'}}>
                        <AtomSpinner color="blue" />            
                    </div>
          }

          {
            this.state.add_student &&
            <div style={{height: '50%',width: '80%',marginLeft:"10%",marginTop:"5%",borderWidth: 5,borderColor: 'black'}}>
                            <AddStudent cancel={this.ShowViewStudent} class_list={this.state.class_list}/>
            </div>
          }


           

        
          </CardBody>
        </Card>
      </Col>
      { (this.state.viewstudentdata!==null && !this.state.loading) &&
             
             <ViewStudent handleClose={()=>{this.setViewStudentVisibility('close')}} 
                    show={this.state.ShowViewStudentModal} 
                    data={this.state.viewstudentdata}
                    edit_student={(code)=>{this.setState({edit_student_code:code});this.setViewStudentVisibility('close');this.setEditModalVisibility('show');}}/>
      }
    </Row>
      <ConfirmModal
            show={this.state.showConfirmModal}
            onHide={() =>this.setConfirmModalVisibility('close')}
            handleClose={() =>this.setConfirmModalVisibility('close')}
            onAccept={()=>this.delete_student(this.state.deletestudentcode)}
            message={"Are you Sure?\nThe data linked to this student will be deleted permanently!"}
        />

        <EditStudent
            show={this.state.showEditModal}
            onHide={() =>this.setEditModalVisibility('close')}
            handleClose={() =>this.setEditModalVisibility('close')}
            student_code={this.state.edit_student_code}
        />
    </Container>
		)
	}
}




class SelectClass extends Component{
  render(){
    return(

          <InputGroup className="mb-3">
                                    <FormSelect onChange={this.props.onChangeHandler}>
                                          <option>{this.props.loading?"Loading...":(this.props.class_list.length>0?"Select Class":"No Classes Available")}</option>
                                          {

                                              this.props.class_list.map((item,i)=>{
                                                             return (<option key={i}>{item}</option>)
                                                })
                                           }
                                      </FormSelect>
      
                                    <InputGroupAddon type="append">
                                    <InputGroupText>Class</InputGroupText>
                                  </InputGroupAddon>
              </InputGroup>
      )
  }
}


class TRow extends Component{
  render(){
    return(

        <tr>
                  <td>{this.props.index}</td>
                  <td> 
                      <div className="blog-comments__avatar mr-3">
                            <img src={this.props.student_list.url} alt={this.props.student_list.name} />
                      </div>
                  </td>
                  <td>{this.props.student_list.name}</td>
                  <td>{this.props.student_list.roll_no}</td>
                  <td>
                      <Button size="sm" theme="info" className="mb-2 mr-1" onClick={()=>{this.props.ViewStudent(this.props.student_list.class,this.props.student_list.roll_no)}}>
                          View
                      </Button>
                  </td>
                  <td style={{fontSize: 20,color:'blue'}}
                      onClick={()=>{this.props.edit_student(this.props.student_list.class+""+this.props.student_list.roll_no)}}>
                      <i class="material-icons">edit</i>
                  </td>
                  <td style={{fontSize: 20,color:'red'}}
                      onClick={()=>{this.props.delete_student(this.props.student_list.class,this.props.student_list.roll_no)}}>
                      <i class="material-icons">delete</i>
                </td>
        </tr>
    )
  }
}